import { create } from 'zustand';

/**
 * Which item's options are open, if any.
 *
 * A store rather than props, because the ways IN are scattered by nature —
 * holding OK on a television, three dots on a tile, a long press on a phone,
 * a right-click, the Options button on a detail page — and they live on
 * different screens. Threading a callback down to every poster on every
 * screen is the parallel registry this codebase keeps learning to avoid: it
 * ends up containing whatever somebody remembered to wire.
 *
 * The dialog itself is rendered once, in the shell.
 */
interface ItemMenuState {
  id: string | null;
  open(id: string): void;
  close(): void;
}

export const useItemMenu = create<ItemMenuState>((set) => ({
  id: null,
  open: (id) => set({ id }),
  close: () => set({ id: null }),
}));
